export default __webpack_public_path__ + "static/media/invoice.8ff3f2c0.svg";